export default __webpack_public_path__ + "static/media/help_triangle.29252611.svg";